import * as o from "react";
import c from "zustand";
const n = typeof window < "u" ? o.useLayoutEffect : o.useEffect;
function a(t) {
  const r = o.useMemo(() => c(t.store), [t]), [, s] = o.useReducer((e) => e + 1, 0);
  return n(() => {
    const e = s, u = t.store.subscribe(e);
    return e(), u;
  }, [t]), r;
}
function i(t, r) {
  return a(t)(r || t.store.getState);
}
export {
  i as default,
  a as useCreateNotificationStore
};
//# sourceMappingURL=useNotificationStore.mjs.map
